export enum imageTypes {
  LOAD_IMAGE = "@@IMAGE/LOAD_IMAGE",
  LOAD_IMAGE_SUCCESS = "@@IMAGE/LOAD_IMAGE_SUCCESS",
  SAVE_IMAGE_META = "@@IMAGE/SAVE_IMAGE_META",
  IMAGE_PROCESSING_COMPLETE = "@@IMAGE/IMAGE_PROCESSING_COMPLETE",
  LOAD_ANNOTATIONS = "@@IMAGE/LOAD_ANNOTATIONS",
  LOAD_ANNOTATIONS_SUCCESS = "@@IMAGE/LOAD_ANNOTATIONS_SUCCESS",
  SET_INITIAL_STATE = "@@IMAGE/SET_INITIAL_STATE",
  ROTATE_IMAGE = "@@IMAGE/ROTATE_IMAGE",
  SET_AS_NOTPROCESSED = "@@IMAGE/SET_AS_NOTPROCESSED",
  SHOW_ANNOTATIONS = "@@IMAGE/SHOW_ANNOTATIONS",
  CHANGE_RADIOGRAPH_TYPE = "@@IMAGE/CHANGE_RADIOGRAPH_TYPE",
  UPDATE_OPENDATEMS = "@@IMAGE/UPDATE_OPENDATEMS",
  SET_PDF_REPORT_DATA = "@@SERVER_DATA/SET_PDF_REPORT_DATA",
  LOAD_PDF_REPORT = "@@IMAGE/LOAD_PDF_REPORT",
  LOAD_PDF_REPORT_SUCCESS = "@@IMAGE/LOAD_PDF_REPORT_SUCCESS",
  OPEN_PDF_REPORT = "@@IMAGE/OPEN_PDF_REPORT",
  SET_SHOW_IMMEDIATELY = "@@IMAGE.SET_SHOW_IMMEDIATELY",
  REANALYZE_IMAGE = "@@IMAGE/REANALYZE_IMAGE",
}

export type PdfReport = Readonly<{
  id: string
  isBoneLossPdf: boolean
}>
